import { render, staticRenderFns } from "./OptionDetail.vue?vue&type=template&id=77268e1e"
import script from "./OptionDetail.vue?vue&type=script&lang=js"
export * from "./OptionDetail.vue?vue&type=script&lang=js"
import style0 from "./OptionDetail.vue?vue&type=style&index=0&id=77268e1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports